import { render, staticRenderFns } from "./staff-selector.vue?vue&type=template&id=59b06f66&scoped=true&"
import script from "./staff-selector.vue?vue&type=script&lang=ts&"
export * from "./staff-selector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b06f66",
  null
  
)

export default component.exports